import actionTypes from '../actions/actionTypes'
import { AnyAction } from 'redux'
import * as Sentry from '@sentry/browser'

const errorCaught = (payload: any, store: any) => {
	Sentry.getCurrentScope().setExtra('game-state', store.getState().game)
	Sentry.captureException(payload.data)
}

const errorHandlingMiddleware = (store: any) => {
	return (next: (action: unknown) => unknown) => (rawAction: unknown) => {
		const action = rawAction as AnyAction
		next(action)
		switch (action.type) {
			case actionTypes.APP_ERROR_CAUGHT:
				errorCaught(action, store)
				break
		}
	}
}

export default errorHandlingMiddleware
